export const STATUS_LABELS = {
  registration: 'Регистрация открыта', ongoing: 'Идёт сейчас', finished: 'Завершён', cancelled: 'Отменён',
};

export const isCurrent = (t) => ['registration', 'ongoing'].includes(t.status);
export const isPublic = (t) => ['registration', 'ongoing', 'finished'].includes(t.status);

// The editor stores datetime-local values in the server's Moscow time.
function dateValue(value) {
  if (!value) return null;
  const date = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}+03:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = dateValue(value);
  return date ? `${new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow',
  }).format(date)} МСК` : 'Дата будет объявлена';
}

export function sortTournaments(tournaments) {
  const priority = { ongoing: 0, registration: 1, finished: 2 };
  return tournaments.filter(isPublic).sort((a, b) => {
    const status = priority[a.status] - priority[b.status];
    if (status) return status;
    const aTime = dateValue(a.startDate)?.getTime();
    const bTime = dateValue(b.startDate)?.getTime();
    if (aTime == null || bTime == null) return (aTime == null) - (bTime == null);
    return a.status === 'finished' ? bTime - aTime : aTime - bTime;
  });
}

export function getWinner(tournament) {
  if (tournament.status !== 'finished') return null;
  const rounds = Array.isArray(tournament.rounds) ? tournament.rounds : [];
  const matches = rounds[rounds.length - 1]?.matches;
  if (!Array.isArray(matches) || matches.length !== 1) return null;
  const match = matches[0];
  return match.winner && match.winner !== 'TBD' && [match.player1, match.player2].includes(match.winner)
    ? match.winner : null;
}

export function getPrizes(tournament) {
  return (Array.isArray(tournament.prizes) ? tournament.prizes : []).map((prize) => ({
    place: Number(prize.place),
    rewards: Array.isArray(prize.rewards) && prize.rewards.length
      ? prize.rewards.map((r) => r.text?.trim()).filter(Boolean)
      : prize.amount ? [`${prize.amount} ${prize.currency || '₽'}`] : [],
  })).filter((p) => p.rewards.length).sort((a, b) => a.place - b.place);
}

export const participantCount = (t) => Array.isArray(t.participants) ? t.participants.length : Number(t.participantCount) || 0;
export const scoreLabel = (score) => score === '' || score == null ? '—' : String(score);
